import { useEffect, useState } from "react";
import { useNavigate } from "react-router";

import axios from "axios";

import { DashboardLayout } from "../../Layout/DashboardLayout";
import BackButton from "../../Components/BackButton";
import CustomInput from "../../Components/CustomInput";
import CustomButton from "../../Components/CustomButton";
import { questionModal, successModal } from "../../Components/CustomModal";
import CustomLoader from "../../Components/CustomLoader";
import { checkAudioFormat } from "../../Util/helpers";

import { placeholderImage } from "../../Assets/images";

import "./style.css";
import BASEURL from "../../Config/global";
import { postRequest } from "../../Util/requests";
import { translateEnglishToSpanish, translateFromSpanish } from "../../Util/translator";
import MultiSelectDropdown from "../../Components/MultiSelectDropdown";

const AddStory = () => {
  const navigate = useNavigate();

  const [storyOptions, setStoryOptions] = useState([]);
  const [subCategories, setSubCategories] = useState([])
  const [mobileAudioDuration, setMobileAudioDuration] = useState(null);

  const [formData, setFormData] = useState({});
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedThumbnail, setSelectedThumbnail] = useState(null);
  const [featuredState, setFeaturedState] = useState(false);
  const [story, setStory] = useState(null);
  const [storyError, setStoryError] = useState(false);

  const [storyImage, setStoryImage] = useState(null);
  const [storyThumbnail, setStoryThumbnail] = useState(null);
  const [childContent, setChildContent] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState('english');


  const [loginError, setLoginError] = useState({ error: false, text: "" });
  const [loader, setLoader] = useState(false);
  const [duplicateLoader, setDuplicateLoader] = useState(false);

  useEffect(() => {
    async function fetchStory() {
      try {
        const languageParam = selectedLanguage === 'spanish' ? '?language=spanish' : '';
        const response = await axios.get(
          `${BASEURL}/api/stories/storiescategories${languageParam}`
        );
        setStoryOptions(response.data.data);
      } catch (error) {
        console.error(error);
      }
    }
    fetchStory();
  }, [selectedLanguage]);

  useEffect(() => {
    if (!formData?.category_ids || formData?.category_ids?.length === 0) {
      setSubCategories([]);
    }
    if (formData?.category_ids?.length > 0 && formData?.category_ids?.length < 2) {
      getSubCategories(formData?.category_ids?.[0]?.value);
    }
  }, [formData?.category_ids, selectedLanguage]);

  const getSubCategories = async (soundcategory) => {
    const requestOptions = {
      method: "GET",
      redirect: "follow"
    };
    const languageParam = selectedLanguage === 'spanish' ? '?language=spanish' : '';
    fetch(`${BASEURL}/api/stories/storiescategories/${soundcategory}${languageParam}`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === 200) {
          const { category_data } = result?.data[0]
          setSubCategories(category_data)
        }
      })
      .catch((error) => console.error(error));
  }

  // useEffect(() => {
  //   const firstCategory = storyOptions[0]?.id.toString();
  //   setFormData({ category: firstCategory });
  // }, [storyOptions]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };
  const handleChangeCategory = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value, soundSubCategory: "undefined" });
  }

  const handleStoryChange = (event) => {
    const audioResult = checkAudioFormat(event);
    handleFileChange(event)
    setStory(audioResult.selectedFile);
    setStoryError(audioResult.error);
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();

      // Load the file into an audio context to get the duration
      reader.onload = (e) => {
        const audioContext = new (window.AudioContext || window.webkitAudioContext)();
        audioContext.decodeAudioData(e.target.result, (buffer) => {
          const duration = buffer.duration;
          setMobileAudioDuration(duration)
          console.log(`The duration of the file is ${duration} seconds.`);
        });
      };

      reader.readAsArrayBuffer(file);
    }
  };
  const handleImageChange = (event) => {
    const file = event.target.files[0];
    setSelectedImage(file);

    if (file === null || file === "undefined") {
      setStoryImage(null);
    } else {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        setStoryImage(reader.result);
      };
    }
  };

  const handleThumbnailChange = (event) => {
    const file = event.target.files[0];
    setSelectedThumbnail(file);

    if (file === null || file === "undefined") {
      setStoryThumbnail(null);
    } else {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        setStoryThumbnail(reader.result);
      };
    }
  };

  const postStory = async (language = null, translatedTitle = null) => {
    const formDataToSend = new FormData();
    formDataToSend.append("image", selectedImage);
    formDataToSend.append("thumbnail", selectedThumbnail);
    story && formDataToSend.append("audio", story);
    formDataToSend.append("video_url", formData?.video_url);
    formDataToSend.append("video_description", formData?.video_description || '');
    formDataToSend.append("title", translatedTitle || formData.title);
    formDataToSend.append("premium", formData.premium);
    // if (formData.soundSubCategory && formData.soundSubCategory !== 'undefined') {
    //   formDataToSend.append("storiescategory", formData.soundSubCategory);
    // } else {
    //   formDataToSend.append("storiescategory", formData.category);
    // }
    if (mobileAudioDuration) {
      formDataToSend.append("duration", mobileAudioDuration);
    }
    formDataToSend.append("featured", featuredState);
    formDataToSend.append("naration", true);
    formDataToSend.append("child_content", childContent);
    formDataToSend.append("category_ids", formData?.category_ids?.map?.((item) => item.value));
    formDataToSend.append("subcategory_ids", formData?.subcategory_ids?.map?.((item) => item.value));


    // Add language to FormData if provided
    if (language) {
      formDataToSend.append("language", language);
    }

    try {
      const response = await postRequest(`/api/stories/`, formDataToSend, null)
      if (response.data.error === false) {
        return { success: true, response: response.data };
      } else {
        return { success: false, error: response.data.message };
      }
    } catch (error) {
      return { success: false, error: "An error occurred. Please try again later." };
    }
  };

  const handleDuplicateAndAdd = async () => {
    if (!formData?.video_url && !story) {
      setLoginError({ error: true, text: "Please fill all required fields first" });
      return;
    }

    setDuplicateLoader(true);
    setLoginError({ error: false, text: "" });

    try {
      // Step 1: Post the first story with current language
      const currentLanguage = selectedLanguage;
      const firstResult = await postStory(currentLanguage, null);

      if (!firstResult.success) {
        setLoginError({ error: true, text: `First story failed: ${firstResult.error}` });
        setDuplicateLoader(false);
        return;
      }

      // Step 2: Translate title to the other language
      let translatedTitle = null;
      const targetLanguage = currentLanguage === 'english' ? 'spanish' : 'english';

      if (formData.title) {
        let translationResult;
        if (currentLanguage === 'english') {
          // Translate English to Spanish
          translationResult = await translateEnglishToSpanish(formData.title);
        } else {
          // Translate Spanish to English
          translationResult = await translateFromSpanish(formData.title);
        }

        if (translationResult.success) {
          translatedTitle = translationResult.translatedText;
        } else {
          setLoginError({ error: true, text: `Translation failed: ${translationResult.error}` });
          setDuplicateLoader(false);
          return;
        }
      }

      // Step 3: Post the second story with translated title and other language
      const secondResult = await postStory(targetLanguage, translatedTitle);

      if (secondResult.success) {
        successModal.fire({
          text: `Story added successfully in both ${currentLanguage} and ${targetLanguage}!`,
          confirmButtonText: "Continue",
        });
        setLoginError({ error: false, text: "" });
        setDuplicateLoader(false);
        navigate("/story-management");
      } else {
        setLoginError({ error: true, text: `Second story failed: ${secondResult.error}` });
        setDuplicateLoader(false);
      }
    } catch (error) {
      setLoginError({
        error: true,
        text: "An error occurred during duplicate operation. Please try again later.",
      });
      setDuplicateLoader(false);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!formData?.category_ids || formData?.category_ids?.length === 0) {
      setLoginError({ error: true, text: "Please select at least one category" });
      return;
    }
    if (formData?.video_url || story) {
      const currentLanguage = selectedLanguage;
      const languageText = currentLanguage === 'english' ? 'English' : 'Spanish';

      questionModal
        .fire({
          title: `Do you want to add this Story in ${languageText}?`,
          confirmButtonText: "Add",
        })
        .then((result) => {
          if (result.isConfirmed) {
            setLoader(true);
            postStory(currentLanguage, null).then((result) => {
              setLoader(false);
              if (result.success) {
                successModal.fire({
                  text: "Story Added Successfully",
                  confirmButtonText: "Continue",
                });
                setLoginError({ error: false, text: "" });
                navigate("/story-management");
              } else {
                setLoginError({ error: true, text: result.error });
              }
            });
          }
        });
    } else {
      setLoginError({ error: true, text: "Fill all required fields." });
    }
  };

  return (
    <>
      <DashboardLayout>
        <div className="container-fluid">
          <div className="row mb-3">
            <div className="col-12 mb-2">
              <h2 className="mainTitle">
                <BackButton />
                Add Story
              </h2>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-12">
              <form onSubmit={handleSubmit}>
                <div className="row mb-3">
                  <div className="col-lg-6 mb-4">
                    <CustomInput
                      label="Title"
                      labelClass="mainLabel"
                      required
                      type="text"
                      name="title"
                      value={formData.title || ""}
                      placeholder="Enter Title"
                      inputClass="mainInput"
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-6"></div>
                  <div className="col-lg-6 mb-4">
                    <p className="mainLabel">Type</p>
                    <label className="secondaryText me-3">
                      <input
                        type="radio"
                        name="premium"
                        required
                        value={"false"}
                        className="me-1"
                        onChange={handleChange}
                      />
                      Free
                    </label>
                    <label className="secondaryText">
                      <input
                        type="radio"
                        name="premium"
                        required
                        value={"true"}
                        className="me-1"
                        onChange={handleChange}
                      />
                      Premium
                    </label>
                  </div>
                  <div className="col-lg-6 mb-4">
                    <p className="mainLabel">Audio*</p>
                    <label>
                      <div className="audioInput">
                        <span>Select Audio File</span>
                      </div>
                      {story && (
                        <p className="audioInputName oneLine">{story.name}</p>
                      )}
                      {storyError && (
                        <p className="audioInputName">
                          Please select correct file format
                        </p>
                      )}
                      <input
                        type="file"
                        name="story"
                        accept="audio/*"
                        className="d-none"
                        onChange={handleStoryChange}
                      />
                    </label>
                  </div>
                  <div className="col-lg-6 mb-4">
                    <CustomInput
                      label="Video"
                      labelClass="mainLabel"
                      type="text"
                      name="video_url"
                      value={formData?.video_url || ""}
                      placeholder="Enter URL"
                      inputClass="mainInput"
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-lg-6 mb-4">
                    <CustomInput
                      label="Video Description"
                      labelClass="mainLabel"
                      type="text"
                      name="video_description"
                      value={formData?.video_description || ""}
                      placeholder="Enter Description"
                      inputClass="mainInput"
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-lg-6 mb-4">
                    <p className="mainLabel">Select Category*</p>
                    <MultiSelectDropdown
                      value={formData.category_ids || ""}
                      name="category_ids"
                      options={storyOptions}
                      onChange={(__data) => {
                        setFormData({ ...formData, category_ids: __data, subcategory_ids: "undefined" });
                      }}
                    />
                  </div>
                  <div className="col-lg-6 mb-4">
                    {
                      (!formData?.category_ids || formData?.category_ids?.length < 2) && (
                        <>
                          <p className="mainLabel">Select SubCategory*</p>
                          <MultiSelectDropdown
                            value={formData.subcategory_ids || ""}
                            name="subcategory_ids"
                            options={subCategories}
                            onChange={(__data) => {
                              setFormData({ ...formData, subcategory_ids: __data });
                            }}
                          />
                        </>
                      )
                    }
                  </div>
                  <div className="col-lg-6 mb-4">
                    <p className="mainLabel">Thumbnail*</p>
                    <label>
                      <div className="thumbnailInput">
                        {storyThumbnail ? (
                          <img src={storyThumbnail} alt="Thumbnail" />
                        ) : (
                          <img src={placeholderImage} alt="Thumbnail" />
                        )}
                      </div>
                      <input
                        type="file"
                        id="image"
                        accept="image/*"
                        className="d-none"
                        required
                        onChange={handleThumbnailChange}
                      />
                    </label>
                  </div>
                  <div className="col-lg-6 mb-4">
                    <p className="mainLabel">Image*</p>
                    <label>
                      <div className="imageInput">
                        {storyImage ? (
                          <img src={storyImage} alt="Main" />
                        ) : (
                          <img src={placeholderImage} alt="Main" />
                        )}
                      </div>
                      <input
                        type="file"
                        id="image"
                        accept="image/*"
                        className="d-none"
                        required
                        onChange={handleImageChange}
                      />
                    </label>
                  </div>
                  <div className="col-3 align-self-end mb-4">
                    <input
                      type="checkbox"
                      name="featured"
                      id="featured"
                      onChange={() => {
                        setFeaturedState(!featuredState);
                      }}
                    />
                    <label htmlFor="featured" className="mainLabel ms-1">
                      Featured
                    </label>
                  </div>
                  <div className="col-lg-3 align-self-end mb-4">
                    <input
                      type="checkbox"
                      name="featured"
                      id="featured"
                      onChange={() => {
                        setChildContent(!childContent);
                      }}
                      value={childContent}
                      checked={childContent ? true : false}
                    />
                    <label htmlFor="featured" className="mainLabel ms-1">
                      underage restriction
                    </label>
                  </div>
                  <div className="col-lg-4 mb-4">
                    <p className="mainLabel">Select Language*</p>
                    <select
                      name="language"
                      id="language"
                      className="mainInput "
                      value={selectedLanguage}
                      onChange={(e) => setSelectedLanguage(e.target.value)}
                    >
                      <option value="english">English</option>
                      <option value="spanish">Spanish</option>
                    </select>
                  </div>
                </div>
                {loginError.error == true && (
                  <div className="row mb-3">
                    <div className="col-12">
                      <p className="secondaryText">{loginError.text}</p>
                    </div>
                  </div>
                )}
                <div className="row">
                  <div className="col-12">
                    <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                      <CustomButton
                        type="submit"
                        variant="primaryButton"
                        text="Add"
                        disabled={loader || duplicateLoader}
                      />
                      {selectedLanguage === 'english' && (
                        <CustomButton
                          type="button"
                          variant="secondaryButton"
                          text="Duplicate in Spanish"
                          onClick={(e) => {
                            e.preventDefault();
                            questionModal
                              .fire({
                                title: "Do you want to add this Story in both English and Spanish?",
                                text: "This will add the story twice - once in English and once in Spanish (with translated title).",
                                confirmButtonText: "Yes, Add Both",
                              })
                              .then((result) => {
                                if (result.isConfirmed) {
                                  handleDuplicateAndAdd();
                                }
                              });
                          }}
                          disabled={loader || duplicateLoader}
                        />
                      )}
                      {selectedLanguage === 'spanish' && (
                        <CustomButton
                          type="button"
                          variant="secondaryButton"
                          text="Duplicate in English"
                          onClick={(e) => {
                            e.preventDefault();
                            questionModal
                              .fire({
                                title: "Do you want to add this Story in both Spanish and English?",
                                text: "This will add the story twice - once in Spanish and once in English (with translated title).",
                                confirmButtonText: "Yes, Add Both",
                              })
                              .then((result) => {
                                if (result.isConfirmed) {
                                  handleDuplicateAndAdd();
                                }
                              });
                          }}
                          disabled={loader || duplicateLoader}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </DashboardLayout>
      {(loader || duplicateLoader) && <CustomLoader />}
    </>
  );
};
export default AddStory;
